import React from 'react'
import ReactDOM from 'react-dom/client'
import Start from './pages/Start.jsx'
import { AuthProvider } from './auth/AuthContext'
import { LanguageProvider, useLang } from './i18n/LanguageContext'
import { startT } from './i18n/startStrings'
import './index.css'

// 公開自助健檢漏斗（qb.quanturing.ai/start）：Google 登入取名單 → 綁品牌 → 秒報 Stage1 分數。
// AuthProvider 包外層（登入態 + 全域 fetch Bearer patch）；登入 UX 在 Start 內自訂（hero landing）。
// LanguageProvider 在最外層（SS03）：/quanbrand/ 的 en／ja CTA 帶 ?lang= 過來，
// 語言要在**登入前**就決定 —— Hero 是這條動線的第一個畫面，它不能是中文的。
ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <LanguageProvider>
      <StartWithLang />
    </LanguageProvider>
  </React.StrictMode>,
)

// AuthProvider 要拿到語言才能決定 GIS 腳本的 ?hl=，而 useLang 只能在 Provider 內用 ——
// 所以中間隔一層。**腳本的語言在載入那一刻就定了，之後換不掉**，
// 因此這一層必須在 AuthProvider 外面。
function StartWithLang() {
  const { lang } = useLang()
  return (
    <AuthProvider gisHl={startT(lang).hero.gisLocale}>
      <Start />
    </AuthProvider>
  )
}
